<div *ngIf="isHttpLoading || isManualLoading" class="app-loader-surface"></div>
<div *ngIf="isHttpLoading || isManualLoading" class="app-loader-spinner flex row center-center">
    <mat-spinner color="white" diameter="45"></mat-spinner>
</div>
